import { useState, useEffect } from 'react';
import { api } from '../App';

export function useProductZoeken() {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const isSearching = query.trim().length > 0;

  useEffect(() => {
    const zoekterm = query.trim();

    if (!zoekterm) {
      setResults([]);
      setLoading(false);
      return undefined;
    }

    setLoading(true);
    const timer = setTimeout(async () => {
      try {
        const response = await api.get(
          `/index.php?action=productzoeken&q=${encodeURIComponent(zoekterm)}`
        );
        setResults(response.data);
      } catch {
        setResults([]);
      } finally {
        setLoading(false);
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [query]);

  return { query, setQuery, results, loading, isSearching };
}
